import type { ReactNode } from 'react';

import { NessoLogo } from '@nesso/ui/icons/nesso-logo';

type Props = {
    dropdown?: ReactNode;
};

export function NavigationBar({ dropdown }: Props) {
    return (
        <header className="bg-background border-border flex h-16 shrink-0 items-center justify-between border-b px-3">
            <div className="flex items-center gap-2">
                <NessoLogo role="img" aria-label="Nesso" />
                <span className="font-medium text-sm">Admin</span>
            </div>
            {dropdown}
        </header>
    );
}
